export default {
  bot_name: 'Bot',
  customer_name: 'Customer',
  priority: 'Priority',
  queue_time: 'Time in Queue',
  sequential_id: 'Ticket',
  team: 'Queue',
};
